/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'

import jMoment from 'moment-jalaali'
import $ from 'jquery'
import {message} from 'antd'
import Select from 'react-select'
import {ExcelExport, grid, gridColumn, gridToolbar} from '@progress/kendo-react-excel-export'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import FromToPicker from '../BaseComponent/FromToPicker'
import SearchProduct from '../BaseComponent/SearchProduct'
import SearchableCombo from '../BaseComponent/searchableCombo'
import DeliveryPackComponent from '../BaseComponent/deliveryPackComponent'
import DeliveryPackPrint from '../BaseComponent/deliveryPackPrint'
import {accounting} from 'accounting'
import RETAIL from '../BaseComponent/RETAIL'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import cookie from 'react-cookies'
import Loader from '../loaders/loader'

class DeliveredMaster extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      buttonClicked: false,
      delivery: [],
      timesInterval: [],
      aggregation: {},
      fromDate: '',
      toDate: '',
      shift: '',
      finalShift: '',
      driverSelect: '',
      finalDriverSelect: '',
      printInfo: [],
      Drivers: [],
      modal: false,
      urlSign: '',
      modalDelete: false
    }
  }

  loadDeliveryPack = (userCode, invoiceId) => {
    http
      .get(
        REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER +
          '?export=false' +
          '&pageSize=10' +
          '&pageNumber=1' +
          `&invoiceId=${invoiceId}&userCode=${userCode}&sortBy=planDate_Desc,planTimeFrom_Asc,invoiceNum_Asc`
      )
      .then((response) => {
        if (response.data.error == null) {
          console.log(response.data)
          $('.showBaseTable,.print').fadeIn()

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            baskets: response.data.object.result,
            lengthbaskets: response.data.object.countAll,
            finalDriverSelect: this.state.driverText,
            finalShift: this.state.shift,
            aggregation: response.data.object.aggregation,
            buttonClicked: true
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    var urlParams = new URLSearchParams(window.location.search)
    var userCode = urlParams.get('userCode') === null ? '' : urlParams.get('userCode')
    var invoiceId = urlParams.get('invoiceId') === null ? '' : urlParams.get('invoiceId')

    if (!(userCode === '' && invoiceId === '')) {
      this.setState({
        userCode,
        invoiceId
      })
      sessionStorage.setItem('pageNumber', '1')
      sessionStorage.setItem('dropDownVal', '10')
      sessionStorage.setItem(
        'params',
        `userCode=${userCode}&invoiceId=${invoiceId}&sortBy=planDate_Desc,planTimeFrom_Asc,invoiceNum_Asc`
      )
      this.loadDeliveryPack(userCode, invoiceId)
      this.setState({
        defaultValueDate: false
      })
    } else {
      sessionStorage.removeItem('params')
    }

    http.get(`public/base/type/timeIntervals`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          timesInterval: response.data.object
        })
      }
    })

    http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_UNIT}`, {}).then((response) => {
      if (response.data.error == null) {
        var unit = response.data.object
        for (let i = 0; i < unit.length; i++) {
          unit[i]['value'] = unit[i].id
          unit[i]['label'] = unit[i].title
        }

        this.setState({
          unit: response.data.object
        })
      } else {
        this.setState({
          unit: []
        })
      }
    })

    http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {
      if (response.data.error == null) {
        var provider = response.data.object
        for (let i = 0; i < provider.length; i++) {
          provider[i]['value'] = provider[i].providerId
          provider[i]['label'] = provider[i].providerId + ' - ' + provider[i].title
        }

        this.setState({
          providers: response.data.object
        })
      } else {
        this.setState({
          providers: []
        })
      }
    })

    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  onResultFetched(data) {
    this.setState({
      delivery: data
    })
  }

  changeDropDown(data) {
    this.setState({
      delivery: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  changeField(e) {
    let target = e.target
    let value = target.value

    this.setState({
      tasvie: value == '' ? '' : Number(value)
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getStocks = (arrayOfStocks) => {
    var stockArr = []

    this.setState({
      arrayOfStocks
    })

    if (arrayOfStocks.length == '0') {
      this.setState({
        finalStocks: []
      })
    } else {
      for (let prop of arrayOfStocks) {
        stockArr.push(prop.value)
        this.setState({
          finalStocks: stockArr
        })
      }
    }
  }

  finalStocks = (finalStocks) => {
    this.setState({
      finalStocks
    })
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  filter() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let planTimeType = document.getElementById('planTimeType').value
    let invoiceNum = this.convertDigit(document.getElementById('invoiceNum').value.trim())
    let invoiceId = this.convertDigit(document.getElementById('invoiceId').value.trim())
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId

    if (planTimeType == '' && driverId == '' && minDate == '' && maxDate == '' && invoiceNum == '' && invoiceId == '') {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ تحویل ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ تحویل انتها صحیح نیست')
    } else {
      this.setState({
        toPrintDate: minDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
        fromPrintDate: maxDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
        loading: true
      })

      sessionStorage.setItem(
        'params',
        `planDateMin=${minDate}&planDateMax=${maxDate}&timeIntervalId=${planTimeType}&invoiceNum=${invoiceNum}&invoiceId=${invoiceId}&driverId=${driverId}&sortBy=planDate_Desc,planTimeFrom_Asc,invoiceNum_Asc`
      )
      http
        .get(
          `${
            REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERED_MASTER
          }?export=false&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
          {}
        )
        .then((response) => {
          if (response.data.error == null) {
            $('.showBaseTable,.print').fadeIn()

            sessionStorage.setItem('countAll', response.data.object.countAll)
            this.setState({
              delivery: response.data.object.result,
              lengthDelivery: response.data.object.countAll,
              finalDriverSelect: this.state.driverText,
              finalShift: this.state.shift,
              aggregation: response.data.object.aggregation,
              buttonClicked: true,
              loading: false
            })
          } else {
            $('.showBaseTable,.print').fadeOut()
            this.setState({
              loading: false
            })
          }
        })
        .catch((error) => {
          this.setState({
            loading: false
          })
        })
    }
  }

  changeShift(e) {
    let target = e.target

    this.setState({
      shift: target.options[target.selectedIndex].text
    })
  }

  submitForm(e) {
    e.preventDefault()
  }

  convertState = (x, y) => {
    if (x == -100) {
      x = 'کنسل'
      // return x;
    } else if (x == -75) {
      x = 'مرجوعی'
      // return x;
    } else if (x == -50) {
      x = 'بازگشتی'
      // return x;
    } else if (x == 100) {
      x = 'تخصیص مجدد'
      // return x;
    } else if (x == -1) {
      x = 'تخصیص داده نشده'
      // return x;
    } else if (x === 1) {
      x = 'فعال'
      // return x;
    } else if (x == 5) {
      x = 'اول فعال'
      // return x;
    } else if (x == 10) {
      x = 'شروع شده'
      // return x;
    } else if (x == 18) {
      x = 'تسویه نشده'
      // return x;
    } else if (x == 20) {
      x = 'تسویه شده'
    }

    if (y) {
      y = 'تخصیص مجدد'
    } else {
      y = ''
    }

    return y == '' ? x : y + ' - ' + x
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERED_MASTER
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['planDate'] = jMoment(excelReport[i]['planDate']).format('jYY/jMM/jDD')
            excelReport[i]['bazeTahvil'] =
              excelReport[i]['planTimeFrom'].substr(0, 5) + ' - ' + excelReport[i]['planTimeTo'].substr(0, 5)
            excelReport[i]['lastState'] = this.convertState(excelReport[i]['lastState'], excelReport[i]['reAssigned'])

            if (excelReport[i].invoice['mobile'] == null) {
              excelReport[i].invoice['mobile'] = '-'
            } else {
              excelReport[i].invoice['mobile'] = excelReport[i].invoice['mobile'].replace(/\+98/g, '0')
            }

            if (excelReport[i].invoice['paid']) {
              excelReport[i].invoice['paid'] = 'پرداخت شده'
            } else {
              excelReport[i].invoice['paid'] = 'پرداخت نشده'
            }

            if (excelReport[i].invoice['canceled']) {
              excelReport[i].invoice['canceled'] = 'کنسل شده'
            } else {
              excelReport[i].invoice['canceled'] = 'کنسل نشده'
            }

            if (excelReport[i].invoice['confirmed']) {
              excelReport[i].invoice['confirmed'] = 'تایید شده'
            } else {
              excelReport[i].invoice['confirmed'] = 'تایید نشده'
            }

            if (excelReport[i].invoice['payOnDelivery']) {
              excelReport[i].invoice['payOnDelivery'] = 'بله'
            } else {
              excelReport[i].invoice['payOnDelivery'] = 'خیر'
            }

            if (excelReport[i].driver == null) {
              excelReport[i].driver = ''
            } else {
              excelReport[i].driver = excelReport[i].driver['name']
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })

    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERED_MASTER
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            printInfo: response.data.object.result,
            aggregation: response.data.object.aggregation,
            loading: false
          })
          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            printInfo: [],
            aggregation: {},
            loading: false
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  openSign = (num) => {
    sessionStorage.setItem('index', num)
    this.setState({
      modal: !this.state.modal
    })
    let {delivery} = this.state

    var deliveryPackId = delivery[num].deliveryPackId
    let data = {
      deliveryPackId: deliveryPackId
    }
    http
      .post(`${RETAIL.RETAIL_COMPANY_DELIVERYPACK_SIGN}`, data, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            urlSign: `data:image/png;base64,${response.data.object}`
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  handleCancel = (e) => {
    sessionStorage.removeItem('index')

    this.setState({
      modal: !this.state.modal
    })
  }

  openDelete = (detailId) => {
    this.setState({
      modalDelete: true,
      detailId
    })
  }

  deleteCancel = () => {
    this.setState({
      modalDelete: false
    })
  }
  deleteOk = () => {
    let {detailId} = this.state
    let data = {
      detailId
    }
    http
      .post(`${RETAIL.RETAIL_MANAGE_DISPATCH_DETAIL_UNDOFINISH}`, data, {})
      .then((response) => {
        if (response.data.error === null) {
          message.success('عملیات با موفقیت حذف شد')
          this.setState({
            modalDelete: false,
            loading: true
          })
          http
            .get(
              `${
                REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERED_MASTER
              }?export=false&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
              {}
            )
            .then((response) => {
              if (response.data.error == null) {
                $('.showBaseTable,.print').fadeIn()

                sessionStorage.setItem('countAll', response.data.object.countAll)
                this.setState({
                  delivery: response.data.object.result,
                  lengthDelivery: response.data.object.countAll,
                  finalDriverSelect: this.state.driverText,
                  finalShift: this.state.shift,
                  aggregation: response.data.object.aggregation,
                  buttonClicked: true,
                  loading: false
                })
              } else {
                $('.showBaseTable,.print').fadeOut()
                this.setState({
                  loading: false
                })
              }
            })
            .catch((error) => {
              this.setState({
                loading: false
              })
            })
        }
      })
      .catch(() => {
        this.setState({loading: false})
      })
  }
  deleteToggle = () => {
    this.deleteCancel()
  }

  render() {
    let {loading} = this.state
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let {urlSign} = this.state
    var params = sessionStorage.getItem('params')
    let reporterName = cookie.load('name')

    let excelColumns = [
      {title: 'نام خریدار', value: 'buyerName'},
      {title: 'نام تحویل گیرنده', value: 'recipientName'},
      {title: 'ادرس', value: 'address'},
      {title: 'موبایل', value: 'mobile'},
      {title: 'تلفن', value: 'phone'},
      {title: 'شیوه ارسال', value: 'deliveryMethodTitle'}
    ]

    let printCol = [
      'ردیف',
      'تاریخ تحویل',
      'بازه تحویل',
      'زمان تحویل',
      'ادرس',
      'شناسه فاکتور',
      'خریدار',
      'وضعیت',
      'پرداخت در محل',
      'رساننده',
      'اتوموبیل',
      'حالت'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable landscapeTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش تحویل شده ها"
              headerColSpan={13}
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={2}
              rightColSpan={5}
              centerColSpan={5}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <thead />
            <tbody>
              {this.state.printInfo.map((items, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{jMoment(items.planDate).format('jYYYY/jM/jD')}</td>
                  <td>{items.planTimeFrom.substr(0, 5) + ' - ' + items.planTimeTo.substr(0, 5)}</td>
                  <td>{items.dispatchDate == null ? '-' : jMoment(items.dispatchDate).format('jYYYY/jM/jD HH:mm')}</td>
                  <td>{items.invoice.invoiceId}</td>
                  <td>{items.invoice.address}</td>
                  {/* <td>{items.invoice.invoiceNum}</td> */}
                  <td>{items.invoice.buyerName}</td>

                  {/* <td>{items.invoice.recipientName}</td> */}
                  {/* <td className='mobileTD'>{items.invoice.mobile==null?'-':items.invoice.mobile.replace(/\+98/g,'0')}</td> */}
                  <td>{items.invoice.paid ? 'پرداخت شده' : 'پرداخت نشده'}</td>
                  <td>{items.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                  <td title={items.driver == null ? '-' : items.driver.mobile.replace(/\+98/g, '0')}>
                    {items.driver == null ? '-' : items.driver.name}
                  </td>
                  <td>{items.car == null ? '-' : items.car.code}</td>
                  <td>{this.convertState(items.lastState, items.reAssigned)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش تحویل شده ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'planDate'}
                field={'planDate'}
                title={'تاریخ تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'bazeTahvil'}
                field={'bazeTahvil'}
                title={'بازه تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceId'}
                field={'invoice.invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              {/* <gridColumn key={'invoiceNum'} field={'invoice.invoiceNum'} title={'شماره فاکتور'} width="100px"
                                        footerCellOptions={{wrap: true, textAlign: 'center'}}/> */}

              <gridColumn
                key={'buyerName'}
                field={'invoice.buyerName'}
                title={'نام خریدار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              {/* <gridColumn key={'recipientName'} field={'invoice.recipientName'} title={'تحویل گیرنده'} width="100px"
                                        footerCellOptions={{wrap: true, textAlign: 'center'}}/> */}

              <gridColumn
                key={'address'}
                field={'invoice.address'}
                title={'آدرس'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'paid'}
                field={'invoice.paid'}
                title={'وضعیت پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'confirmed'}
                field={'invoice.confirmed'}
                title={'وضعیت تایید'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'canceled'}
                field={'invoice.canceled'}
                title={'وضعیت کنسل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payOnDelivery'}
                field={'invoice.payOnDelivery'}
                title={'پرداخت در محل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'driver'}
                field={'driver'}
                title={'رساننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'lastState'}
                field={'lastState'}
                title={'حالت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'carCode'}
                field={'car.code'}
                title={'کد اتومبیل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>تحویل فاکتور ها</li>
            <li>تحویل شده ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERED_MASTER}
                  showRow={false}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl="printBaskets"
                  printLink=""
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERED_MASTER + '?export=true'}
                  excelColumns={excelColumns}
                  activeExcel={false}
                  titleAdd="افزودن شهر"
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ تحویل از"
                  toLabel="تاریخ تحویل تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label>شیفت زمانی :</label>
                  <select className="form-control" onChange={this.changeShift.bind(this)} id="planTimeType">
                    <option value="">-------</option>
                    {this.state.timesInterval.map((shift, index) => (
                      <option value={shift.timeIntervalId}>{shift.timeStart + ' تا ' + shift.timeEnd}</option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label>شناسه فاکتور:</label>
                  <input
                    type="text"
                    defaultValue={this.state.invoiceId}
                    className="form-control"
                    id="invoiceId"
                    name="invoiceId"
                  />
                </div>

                <div className="formComponent">
                  <label>شماره فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceNum" name="invoiceNum" />
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>تاریخ تحویل</td>
                    <td>بازه تحویل</td>
                    <td>زمان تحویل</td>
                    <td>شناسه فاکتور</td>
                    <td>آدرس</td>
                    {/* <td>شماره فاکتور</td> */}
                    <td> خریدار</td>
                    {/* <td> تحویل گیرنده</td> */}
                    {/* <td>موبایل</td> */}
                    <td>وضعیت پرداخت</td>
                    <td>پرداخت در محل</td>
                    <td>رساننده</td>
                    <td>کد اتومبیل</td>
                    <td>حالت</td>
                    <td>نوع تحویل</td>
                    <td>جزییات</td>
                    <td>حذف</td>
                  </tr>
                  {this.state.delivery.map((items, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{jMoment(items.planDate).format('jYYYY/jM/jD')}</td>
                      <td>{items.planTimeFrom.substr(0, 5) + ' - ' + items.planTimeTo.substr(0, 5)}</td>
                      <td>
                        {items.dispatchDate == null ? '-' : jMoment(items.dispatchDate).format('jYYYY/jM/jD HH:mm')}
                      </td>
                      <td>{items.invoice.invoiceId}</td>
                      {/* <td>{items.invoice.invoiceNum}</td> */}
                      <td>{items.invoice.address}</td>
                      <td>{items.invoice.buyerName}</td>

                      {/* <td>{items.invoice.recipientName}</td> */}
                      {/* <td className='mobileTD'>{items.invoice.mobile==null?'-':items.invoice.mobile.replace(/\+98/g,'0')}</td> */}
                      <td>{items.invoice.paid ? 'پرداخت شده' : 'پرداخت نشده'}</td>
                      <td>{items.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                      <td title={items.driver == null ? '-' : items.driver.mobile.replace(/\+98/g, '0')}>
                        {items.driver == null ? '-' : items.driver.name}
                      </td>
                      <td>{items.car == null ? '-' : items.car.code}</td>
                      <td>{this.convertState(items.lastState, items.reAssigned)}</td>
                      <td>
                        {items.lastState == '20' && items.hasSign ? (
                          <button onClick={() => this.openSign(index)}>
                            <img
                              style={items.hasSign ? {display: 'block'} : {display: 'none'}}
                              src={require('../../image/signature.svg')}
                            />
                          </button>
                        ) : items.lastState == '20' && !items.hasSign ? (
                          ' کد'
                        ) : (
                          '-'
                        )}
                      </td>
                      <td>
                        <Link
                          to={`/deliveryDetails/${items.deliveryPackId}/${items.invoice.invoiceNum}/${
                            items.invoice.invoiceId
                          }/${items.invoice.buyerName}/${items.detailId}`}
                          target="_blank"
                        >
                          <img src={require('../../image/details.svg')} alt="" />
                        </Link>
                      </td>
                      <td>
                        <button onClick={() => this.openDelete(items.detailId)}>
                          <img src={require('../../image/trash.svg')} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Modal isOpen={this.state.modal} toggle={this.toggle} size="sm">
                <ModalHeader toggle={this.toggle}>نمایش امضا</ModalHeader>
                <ModalBody>
                  <div className="imageSign">
                    <img src={urlSign} alt="" />
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button color="danger" onClick={this.handleCancel}>
                    بستن
                  </Button>
                </ModalFooter>
              </Modal>
            </div>

            <div className="paginationWrapp showBaseTable print">
              <Page
                defaultCurrent={1}
                total={this.state.lengthDelivery}
                onResultFetched={this.onResultFetched.bind(this)}
                url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DELIVERED_MASTER}
                urlParams={params + '&sortBy=planDate_Desc'}
              />
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalDelete} toggle={this.deleteToggle} size="sm">
          <ModalHeader toggle={this.deleteToggle}>حذف</ModalHeader>
          <ModalBody>
            <p>آیا از حذف مطمئن هستید؟؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف
            </button>
            <button className="cancelBtnModal" onClick={this.deleteCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default DeliveredMaster
